import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';
import { FaPaintBrush, FaTools, FaPalette } from 'react-icons/fa';
import UnderConstruction from '../../../components/UnderConstruction';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { useAuthStore } from '../../../auth/state';
import './designer_dashboard.css';

// # Helper function to get display name - moved outside component
const getDisplayName = (userProfile, user) => {
  let name = '';
  let username = '';

  // Get name
  if (userProfile?.lastName) {
    name = `${userProfile.lastName}`;
  } else if (userProfile?.firstName) {
    name = `${userProfile.firstName}`;
  } else {
    name = `${user?.email?.split('@')[0] || 'Designer'}`;
  }

  // Get username
  if (userProfile?.username) {
    username = `@${userProfile.username}`;
  }

  return { name, username };
};

// # Helper function to get profile photo URL - moved outside component
const getProfilePhotoUrl = (userProfile) => {
  try {
    if (!userProfile?.photoURL) return '/icons/pfp.png';
    if (userProfile.photoURL === '') return '/icons/pfp.png';
    
    // Check if it's a full URL (from Storage)
    if (userProfile.photoURL.startsWith('http')) {
      return userProfile.photoURL;
    }
    
    // If it's just a filename, assume it's the default
    return '/icons/pfp.png';
  } catch (error) {
    console.error('Error getting profile photo:', error);
    return '/icons/pfp.png';
  }
};

// # Designer Dashboard component
const DesignerDashboard = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuthStore();

  // # Memoize display name to prevent unnecessary recalculations
  const displayName = React.useMemo(() => 
    getDisplayName(userProfile, user), [userProfile, user]);

  return (
    <div className="dsgn_dsh_container">
      {/* # Use shared header component */}
      <DashboardHeader />

      {/* # Cover Image */}
      <div className="dsgn_dsh_cover-section">
        <img 
          src="/icons/cover_ocean.jpg" 
          alt="Cover" 
          className="dsgn_dsh_cover-image"
        />
        
        {/* # Title Logo */}
        <div className="dsgn_dsh_title-logo">
          <FaPalette />
          <h1>Designer Portal</h1>
        </div>
      </div>

      {/* # Profile Section */}
      <div className="dsgn_dsh_profile-section">
        <div 
          className="dsgn_dsh_profile-image-container"
          onClick={() => navigate('/designer-dashboard/profile')}
        >
          <img 
            src={getProfilePhotoUrl(userProfile)}
            alt="Profile" 
            className="dsgn_dsh_profile-image"
          />
        </div>
        <div className="dsgn_dsh_profile-info">
          <h2 className="dsgn_dsh_profile-name">
            {displayName.name}
          </h2>
          <div className="dsgn_dsh_user_username">
            {displayName.username}
          </div>
        </div>
      </div>
      
      <div className="dsgn_dsh_content">
        <Paper className="dsgn_dsh_paper">
          <Typography variant="h5" className="dsgn_dsh_title">
            <FaPaintBrush size={24} /> Designer Dashboard
          </Typography>
          
          {/* # Use the UnderConstruction component */}
          <UnderConstruction pageName="Designer Dashboard" />
        </Paper>
      </div>
      
      <DashboardFooter />
    </div>
  );
};

export default DesignerDashboard; 